"use client";

import { Download, ExternalLink, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

export default function ResumeButton() {
    const [resumeUrl, setResumeUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchResume() {
            try {
                const res = await fetch('/api/upload/resume');
                const data = await res.json();

                if (data.success && data.data?.file_url) {
                    setResumeUrl(data.data.file_url);
                }
            } catch (error) {
                console.error('Failed to fetch resume:', error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchResume();
    }, []);

    // Don't show button if no resume is uploaded
    if (isLoading) {
        return (
            <div className="flex items-center bg-accent/80 text-white rounded-full px-5 py-5">
                <Loader2 className="w-4 h-4 animate-spin" />
            </div>
        );
    }

    if (!resumeUrl) {
        return null; // Hide button if no resume
    }

    return (
        <div className="flex items-center bg-accent text-white rounded-full transition-colors duration-200 group">
            {/* View Resume (Main Action) */}
            <a
                href="/api/resume/download?type=view"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-5 hover:bg-accent-hover transition-colors font-semibold rounded-l-full"
                aria-label="View Resume"
            >
                Resume
                <ExternalLink className="w-4 h-4" />
            </a>

            {/* Divider */}
            <div className="w-[1px] h-6 bg-white/20" />

            {/* Download Resume (Secondary Action) */}
            <div className="relative">
                <a
                    href="/api/resume/download"
                    className="flex items-center justify-center px-4 py-6 hover:bg-accent-hover transition-colors peer rounded-r-full"
                    aria-label="Download Resume"
                >
                    <Download className="w-8 h-4" />
                </a>

                {/* Tooltip */}
                <span className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-1.5 text-xs font-medium rounded-md pointer-events-none opacity-0 -translate-y-2 peer-hover:opacity-100 peer-hover:translate-y-0 transition-all duration-200 whitespace-nowrap shadow-lg z-50 bg-foreground text-background">
                    Download resume
                    {/* Arrow */}
                    <span className="absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent border-b-foreground" />
                </span>
            </div>
        </div>
    );
}
